document.addEventListener('DOMContentLoaded', () => {

	class DefaultFilters extends HTMLElement {
		constructor() {
			super();

			this.openTriger = this.querySelector('.show-filters .item');
			this.filterContent = this.querySelector('collapsible-elements');
			this.triggersCloseAll = this.querySelector('#clear-all');
			this.closeTriger = this.querySelector('.close');
			this.closeTrigerMobile = this.querySelectorAll('.mobile-close');
			this.headerTriggers = this.querySelectorAll('.filters-header .header-item');
			this.tabContentItems = this.querySelectorAll('.filter-items .filter-item');
			this.tabContentItemsInputs = Array.from(this.querySelectorAll('.filter-items .filter-item input'));
			this.tabContentItemsInputsMobile = Array.from(this.querySelectorAll('.header-item .sidebar__item input'));
			this.applyTrigger = this.querySelector('.buttons-box.desktop .apply');
			this.applyTriggerMobile = this.querySelector('.filters-header .buttons-box .apply');
			this.resetTrigger = this.querySelector('.buttons-box.desktop .clear');
			this.resetTriggerMobile = this.querySelector('.filters-header .clear');
			this.selectSortBy = this.querySelector('#sort-by-menu select');
			this.headerItems = this.querySelectorAll('.header-item ');
			this.filterItems = this.querySelectorAll('.filter-item ');
			// this.frames = Array.from(this.querySelectorAll('.frames-selected'));

			this.headerItems.forEach((item, index) => {
				if(index === 0) {
					this.filterItems[index].classList.add('active');
					item.classList.add('active');
				};
			})
			this.init();
		}

		init() {
			this.openFilters();
			this.closeTriggerFunction();
			this.selectTabs();
			this.readFilters();
			this.applyEnable();
			this.applyInit();
			this.resetInit();
			this.selectSortByInit();
			this.sortingFunction();
			this.initRadioFilters();
			this.initClearAll();

			this.triggersCloseAll.addEventListener('click', () => {
				this.resetTrigger.click();
				this.initClearAll();
			})
			
		}

		initRadioFilters() {
			const filterGroups = this.querySelectorAll('.filter-item');
			const filterGroupsMobile = this.querySelectorAll('.header-item');

			removeChecked(filterGroups);
			removeChecked(filterGroupsMobile);
			insertItems();


			function debounce(func, delay) {
				let timeoutId;
				return function() {
					clearTimeout(timeoutId);
					timeoutId = setTimeout(() => func.apply(this, arguments), delay);
				};
			}


			function removeChecked(elements) {
				elements.forEach(group => {
					const filters = group.querySelectorAll('input');

					filters.forEach(filter => {
						filter.addEventListener('change', debounce((evt) => {
							const otherFilters = Array.from(filters).filter(otherFilter => otherFilter !== filter);

							if (filter.checked) {
								otherFilters.forEach(otherFilter => {
									otherFilter.checked = false;
								});
							}

							// if (evt.target.checked !== evt.target.defaultChecked) {
							// 	insertItems();
							// }

							insertItems();

						}, 200));
					});
				});
			}



			function insertItems() {

				const checkedFilters = Array.from(document.querySelectorAll('.buttons-box'));
				const desktopCheckedFilters = Array.from(document.querySelectorAll('.filter-items .filter-item input')).filter(input => input.checked);
				const mobileCheckedFilters = Array.from(document.querySelectorAll('.header-item .sidebar__item input')).filter(input => input.checked);

				checkedFilters.forEach(box => {
					const text = box.querySelector('.clear .text');
					text.classList.add('active');

					if(box.classList.contains('desktop')) {
						text.textContent = desktopCheckedFilters.length;
					} else {
						text.textContent = mobileCheckedFilters.length;
					}
				})
			}

		}
		// initFrames() {
		// 	this.frames.forEach(frame => {
		// 		const num = frame.querySelector('.num');
		// 		num.textContent = document.querySelector('.product-listing').dataset.frames;
		// 	})
		// }

		initClearAll() {
			const inputs = this.tabContentItemsInputs.filter(input => input.checked);
			const inputsMobile = this.tabContentItemsInputsMobile.filter(input => input.checked);

			if(inputs.length > 0 || inputsMobile.length > 0) {
				this.triggersCloseAll.classList.remove('hide');
			} else {
				this.triggersCloseAll.classList.add('hide');
			}
		}

		sortingFunction() {
			this.tabContentItems.forEach(parent => {
				const parentItems = parent.querySelector('.collection-nav');
				const items = Array.from(parent.querySelectorAll('.sidebar__item'));

				items.sort((a, b) => {
					const tagA = a.dataset.tag && a.dataset.tag.toLowerCase();
					const tagB = b.dataset.tag && b.dataset.tag.toLowerCase();
					if (tagA < tagB) return 1;
					if (tagA > tagB) return -1;
					return 0;
				});

				items.forEach(item => item.parentNode.removeChild(item));
				items.forEach(item => parentItems.appendChild(item));
			})
		}

		selectSortByInit() {
			this.selectSortBy.addEventListener('change', (evt) => {
				const urlParams = new URLSearchParams(window.location.search);
				const queryParams = {};

				for (const [key, value] of urlParams.entries()) {
					if (!queryParams[key]) {
						queryParams[key] = value;
					} else {
						if (!Array.isArray(queryParams[key])) {
							queryParams[key] = [queryParams[key]];
						}
						queryParams[key].push(value);
					}
				}

				if (!queryParams[`${evt.target.name}`] || queryParams[`${evt.target.name}`]) {
					queryParams[`${evt.target.name}`] = evt.target.value;
				}

				const params = new URLSearchParams();

				for (const key in queryParams) {
					if (Array.isArray(queryParams[key])) {
						queryParams[key].forEach(value => {
							params.append(key, value);
						});
					} else {
						params.set(key, queryParams[key]);
					}
				}

				const url = new URL(window.location.href);
				url.search = params.toString();

				window.history.replaceState({}, '', url);

				window.location.reload();
			});
		}

		async resetInit() {
			this.resetTrigger.addEventListener('click', async () => {
				this.tabContentItemsInputsMobile.filter(input => input.checked = false);
				const inputChecked = this.tabContentItemsInputs.filter(input => input.checked = false);
				let url = this.createURL(inputChecked);

				if(url.includes('?')) {
					url = url.split('?')[0]
				}

				window.location.href = url;

				return

				try {
					const result = await this.submit(url);
					if (result) {
						const body = document.querySelector('body');
						body.classList.add('filter-open');
						body.parentNode.classList.add('filter-open');

						this.openTriger.parentNode.classList.add('open');
						this.filterContent.classList.add('open');
						this.closeFilters();
					} else {
						console.log('Submission failed');
					}
				} catch (error) {
					console.error('Error submitting:', error);
				}
			});

			this.resetTriggerMobile.addEventListener('click', async () => {
				this.tabContentItemsInputs.filter(input => input.checked = false)
				const inputChecked = this.tabContentItemsInputsMobile.filter(input => input.checked = false);
				const url =  this.createURL(inputChecked);

				try {
					const result = await this.submit(url);
					if (result) {
						const body = document.querySelector('body');
						body.classList.add('filter-open');
						body.parentNode.classList.add('filter-open');

						this.openTriger.parentNode.classList.add('open');
						this.filterContent.classList.add('open');
					} else {
						console.log('Submission failed');
					}
				} catch (error) {
					console.error('Error submitting:', error);
				}
			})
		}

		createURL(elements) {
			const currentURL = window.location.href;
			const urlParts = currentURL.split('?');
			const cleanURL = urlParts[0];
			const inputQuery = elements.map(element => `${element.name}=${element.value.replace(' ', '+')}` );

			// const btnNext = document.querySelector('[data-show-more-button]')
			// btnNext.href = `${cleanURL}?${inputQuery.join('&')}?page=2&view=xhr;`

			return `${cleanURL}?${inputQuery.join('&')}`;
		}

		async submit(url) {
			return new Promise((resolve, reject) => {
				history.pushState(null, null, url);

				fetch(url + '&view=xhr', {
					method: 'GET'
				})
					.then(response => response.text())
					.then(res => {
						this.initRadioFilters();

						// const html = document.createElement('div');
						// html.innerHTML = res;
						// const productBox = html.querySelector('.product-listing');
						// const myProductBox = document.querySelector('.product-listing');
						//
						// myProductBox.parentNode.replaceChild(productBox, myProductBox);
						//
						// const products = document.querySelectorAll('.product-listing [data-product-grid-item]');
						// products.forEach(product => {
						// 	const link = product.querySelector('.product-grid-item__media');
						//
						// 	const swatches = product.querySelectorAll('.product-grid-item__swatches .swatch');
						// 	swatches.forEach(swatch => {
						// 		if(swatch.classList.contains('is-selected')) {
						// 			link.href = link.href.includes('?') ? link.href + `&variant=${swatch.dataset.variantId}` : link.href + `?variant=${swatch.dataset.variantId}`
						// 		}
						// 	})
						// })

						this.closeFilters();
						this.initClearAll();

						resolve(true);
						window.location.reload();

					})
					.catch(error => {
						console.error('Error:', error);
						reject(error);
					})
			});
		}


		applyInit() {
			this.applyTrigger.addEventListener('click', () => {
				const inputChecked = this.tabContentItemsInputs.filter(input => input.checked);

				const url =  this.createURL(inputChecked);
				this.submit(url);

			})

			this.applyTriggerMobile.addEventListener('click', () => {
				const inputChecked = this.tabContentItemsInputsMobile.filter(input => input.checked);

				const url =  this.createURL(inputChecked);
				this.submit(url);
			})
		}

		applyEnable() {
			this.tabContentItemsInputs.forEach(input => {
				input.addEventListener('change', (evt) => {
					this.readFilters();
				});
			})

			this.tabContentItemsInputsMobile.forEach(input => {
				input.addEventListener('change', () => this.readFilters());
			})
		}

		readFilters() {
			this.tabContentItemsInputs = Array.from(this.querySelectorAll('.filter-items .filter-item input'));
			this.tabContentItemsInputsMobile = Array.from(this.querySelectorAll('.header-item .sidebar__item input'));

			const inputChecked = this.tabContentItemsInputs.filter(input => input.checked);
			const inputCheckedMobile = this.tabContentItemsInputsMobile.filter(input => input.checked);

			if(inputChecked.length >= 1 || inputCheckedMobile.length >= 1) {
				this.applyTrigger.classList.remove('disabled');
				this.applyTriggerMobile.classList.remove('disabled');
				return true;
			}
			this.applyTrigger.classList.add('disabled');
			this.applyTriggerMobile.classList.add('disabled');
			return false
		}

		openFilters() {
			this.openTriger && this.openTriger.addEventListener('click', () => {
				const body = document.querySelector('body');
				body.classList.add('filter-open');
				body.parentNode.classList.add('filter-open');

				this.openTriger.parentNode.classList.add('open');
				this.filterContent.classList.add('open');
			})
		}

		closeTriggerFunction() {
			const body = document.querySelector('body');

			this.closeTriger.addEventListener('click', () => this.closeFilters());
			this.closeTrigerMobile.forEach(trigger => {
				trigger.addEventListener('click', () => this.closeFilters())
			});

			document.addEventListener('keydown', () => {
				if (event.keyCode === 27) this.closeFilters();
			})

			body.addEventListener('click', (e) => {
				if(e.target.classList.contains('filter-open')) this.closeFilters();
			})
		}

		closeFilters() {
			const body = document.querySelector('body');
			body.classList.remove('filter-open');
			body.parentNode.classList.remove('filter-open');

			this.openTriger.parentNode.classList.remove('open');
			this.filterContent.classList.remove('open');
		}

		selectTabs() {
			this.headerTriggers.forEach((trigger, index) => {
				trigger.addEventListener('click', () => {
					if(!trigger.classList.contains('active')) {
						this.removeClassActive(this.tabContentItems);
						this.removeClassActive(this.headerTriggers);

						trigger.classList.add('active');
						this.tabContentItems[index].classList.add('active');
					}
					else {
						trigger.classList.remove('active');
						this.tabContentItems[index].classList.remove('active');
					}
				})
			})
		}

		removeClassActive(elements) {
			if(elements.length < 1) return

			elements.forEach(elem => {
				elem.classList.remove('active');
			})
		}
	}

	if (!customElements.get('collection-filters-form')) {
		// customElements.define('collection-filters-form', CollectionFiltersForm);
		customElements.define('collection-filters-form', DefaultFilters);
	}
});


